import React from 'react';

export default class ExpiredTag extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className="ExpiredTag my-0">
				<span className="tag">{I18n.t('admin.expired_tag')}</span>
			</div>
		);
	}
}
